const ACTION_CONTENT_BORDER_RADIUS = "62.4375rem";
const ACTION_CONTENT_BACKGROUND_COLOR = "rgba(18, 70, 200, 0.04)";
const FILTER_GRAYSCALE = "grayscale(100%)";
const CARD_CONTAINER_BORDER_THICK = "0.063rem";
const MIDDLE_OPACITY = 0.5;
const MAX_OPACITY = 1;
export {
  ACTION_CONTENT_BACKGROUND_COLOR,
  ACTION_CONTENT_BORDER_RADIUS,
  CARD_CONTAINER_BORDER_THICK,
  FILTER_GRAYSCALE,
  MAX_OPACITY,
  MIDDLE_OPACITY
};
//# sourceMappingURL=product-card.constants.es.js.map
